import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import CommissionRecordInfo from "./commission-record-info.vue";
import { useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { useAddress } from "@Shared/@Composables/generic/useAddress";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { capitalize, isNil } from "lodash";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import { useI18n } from "vue-i18n-composable";
import { formatDateShort } from "@Shared/@Utils/helpers/dates";
export default defineComponent({
  name: "CommissionRecordContainer",
  components: {
    CommissionRecordInfo
  },
  props: {
    currentCommissionsMortgageType: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const {
      tc
    } = useI18n();
    const {
      currentCommissionsMortgageType
    } = toRefs(props);
    const {
      GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE,
      CURRENT_APPLICATION_PRINCIPAL_BORROWER,
      CALCULATED_VALUES_BY_MORTGAGE_TYPE,
      MORTGAGE_AMOUNT,
      GET_LATEST_LENDER_SUBMISSION,
      CURRENT_APPLICATION
    } = useApplicationStoreGetters([ApplicationGetters.GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE, ApplicationGetters.NOT_REQUESTED_MORTGAGES, ApplicationGetters.CURRENT_APPLICATION_PRINCIPAL_BORROWER, ApplicationGetters.CALCULATED_VALUES_BY_MORTGAGE_TYPE, ApplicationGetters.MORTGAGE_AMOUNT, ApplicationGetters.GET_LATEST_LENDER_SUBMISSION, ApplicationGetters.CURRENT_APPLICATION]);
    const currentApplicationSubmissionDetails = computed(() => GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE.value(currentCommissionsMortgageType.value));
    const currentLenderSubmission = computed(() => GET_LATEST_LENDER_SUBMISSION.value(currentCommissionsMortgageType.value));
    const currentLenderSubmissionIsAccepted = computed(() => {
      var _currentLenderSubmiss;
      return ((_currentLenderSubmiss = currentLenderSubmission.value) == null ? void 0 : _currentLenderSubmiss.status) === "accepted";
    });
    const currentLenderResponse = computed(() => {
      var _currentLenderSubmiss2;
      return ((_currentLenderSubmiss2 = currentLenderSubmission.value) == null ? void 0 : _currentLenderSubmiss2.lenderResponse) || {};
    });
    const principalBorrower = computed(() => CURRENT_APPLICATION_PRINCIPAL_BORROWER.value);
    const propertyAddress = computed(() => CURRENT_APPLICATION.value["property"].details.address);
    const loanType = computed(() => {
      var _currentApplicationSu, _currentApplicationSu2, _currentApplicationSu3;
      const valueToUse = (_currentApplicationSu = (_currentApplicationSu2 = currentApplicationSubmissionDetails.value) == null ? void 0 : (_currentApplicationSu3 = _currentApplicationSu2["submission-details"]) == null ? void 0 : _currentApplicationSu3["loan-type"]) != null ? _currentApplicationSu : "";
      return capitalize(valueToUse);
    });
    const lender = computed(() => {
      var _currentLenderRespons, _currentApplicationSu4;
      const lenderFromSubmission = currentLenderSubmissionIsAccepted.value ? (_currentLenderRespons = currentLenderResponse.value.lenderInformation) == null ? void 0 : _currentLenderRespons.lender : currentLenderSubmission.value.lenderName;
      return lenderFromSubmission || ((_currentApplicationSu4 = currentApplicationSubmissionDetails.value["submission-details"]) == null ? void 0 : _currentApplicationSu4["lender"]) || "";
    });
    const lenderReferenceNumber = computed(() => {
      var _currentLenderRespons2, _currentLenderRespons3;
      return ((_currentLenderRespons2 = currentLenderResponse.value) == null ? void 0 : (_currentLenderRespons3 = _currentLenderRespons2.lenderInformation) == null ? void 0 : _currentLenderRespons3.lenderReferenceNumber) || "";
    });
    const term = computed(() => {
      var _currentLenderRespons4, _currentApplicationSu5, _currentApplicationSu6;
      const lenderResponseTerm = ((_currentLenderRespons4 = currentLenderResponse.value.responseDetails) == null ? void 0 : _currentLenderRespons4.term) || "";
      if (currentLenderSubmissionIsAccepted.value) return lenderResponseTerm;
      const mortgageTermYears = ((_currentApplicationSu5 = currentApplicationSubmissionDetails.value["submission-details"]) == null ? void 0 : _currentApplicationSu5["term-years"]) || "";
      const mortgageTermMonths = ((_currentApplicationSu6 = currentApplicationSubmissionDetails.value["submission-details"]) == null ? void 0 : _currentApplicationSu6["term-months"]) || "";
      const yearsText = mortgageTermYears ? `${mortgageTermYears} ${tc("global.words.year", 2)}` : "";
      const monthsText = mortgageTermMonths ? `${mortgageTermMonths} ${tc("global.words.month", 2)}` : "";
      return `${yearsText} ${monthsText}`;
    });
    const netRate = computed(() => {
      var _currentLenderRespons5;
      const lenderResponseRate = ((_currentLenderRespons5 = currentLenderResponse.value.responseDetails) == null ? void 0 : _currentLenderRespons5.rate) || "";
      if (currentLenderSubmissionIsAccepted.value) return `${_parseFloat(lenderResponseRate).toFixed(4)} %`;
      const calculatedValues = CALCULATED_VALUES_BY_MORTGAGE_TYPE.value(currentCommissionsMortgageType.value);
      const mortgageNetRate = !isNil(calculatedValues.netRate) ? `${_parseFloat(calculatedValues.netRate).toFixed(4)} %` : "";
      return mortgageNetRate;
    });
    const closingDate = computed(() => {
      if (currentLenderSubmissionIsAccepted.value) return currentLenderResponse.value.responseDetails.closingDate;
      const applicationClosingDate = CURRENT_APPLICATION.value["mortgage-details"]["mortgage-details"]["closing-date"];
      return applicationClosingDate && formatDateShort(applicationClosingDate);
    });
    const fundedAmount = computed(() => {
      const valueToUse = currentLenderSubmissionIsAccepted.value ? currentLenderResponse.value.applicationSummary.totalLoanAmount : MORTGAGE_AMOUNT.value(currentCommissionsMortgageType.value);
      return formatMoneyValueLong(valueToUse);
    });
    const commissionRecordInfo = computed(() => ({
      principalBorrower: principalBorrower.value,
      propertyAddress: useAddress(propertyAddress.value).fullAddress.value,
      closingDate: closingDate.value,
      netRate: netRate.value,
      lenderReferenceNumber: lenderReferenceNumber.value,
      fundedAmount: fundedAmount.value,
      loanType: loanType.value,
      term: term.value,
      lender: lender.value
    }));
    return {
      currentLenderSubmission,
      commissionRecordInfo,
      currentApplicationSubmissionDetails
    };
  }
});